export default __webpack_public_path__ + "static/kingdom_school_small_video-e493a7ce21a1a3fae8ea23d53c4f7765.mp4";